var magnifier =
webpackJsonp_name_([14],{

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(556);

__webpack_require__(423);

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = MagnifierControl;

var _lbsPiDash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lbsPiDash);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _objects = __webpack_require__(16);

var _helpers = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//    This implementation of magnification does not update the magnified image while
//    drag or resize is happening. Instead it removes the magnified image and permits
//    the viewport image to be visible within the outline of the magnifier.
//    This is because the current magnification implementation goes to the server for
//    each image update.  A better way would be to get a larger region or to build
//    a view like viewport does.
//
// look into   http://jonraasch.com/blog/css-rounded-corners-in-all-browsers
//        http://api.jquery.com/category/css/
//        http://jqueryui.com/demos/draggable/handle.html  drag by handle
//        http://jqueryui.com/demos/draggable/events.html events
//    improvements:
//        - I'm not certain magSuspend is nec anymore.  Mode changes can now show/hide overlays.

var defaults = {
    layout: { 'divClass': _defines2.default.clsDIVMAG, 'precinct': 'BR', 'order': 1, 'canBePlaced': true }
};

function MagnifierControl(uScope, viewport) {
    var self = this;
    var isLoaded = false; // magnifier has been loaded
    var namespace = viewport.eventNameSpaceGet();

    var jVpDiv = viewport.vpDivGet('outer');
    var jMagCtlDiv;
    var magSuspended = true; // magnifier suspension; start it suspended & in modes like autopanning, suspend it

    var prefVisibleDef = false; // magnifier visibility preference default
    var magSpecs = { // magnifier settings
        'minDiameter': 64,
        'maxDiameter': 400, // resize limits in pixels
        'initialDiameter': 150, // initial size in pixels
        'minFactor': 1,
        'maxFactor': 4, // magnification limits in percent
        'magFactor': 2 // current magnification factor
    };
    var xHairFullDiam_ = false; // do full diameter crosshairs
    var xHairAlwaysShow_ = false; // always show the crosshairs

    var navModesImHiddenIn = {}; // what navigation modes not to display the label

    var layout = _.clone(defaults.layout); // magnifier layout info, clone the global set so I can modify it
    var reLayout = viewport.overLayout.refreshPrecinct;

    //............................................ construct_ local
    var construct_ = function construct_() {
        if (_defines2.default.ENABLEMAG == false) return;
        navModesImHiddenIn[_defines2.default.eNavModes.nmRasterScan] = true; // hide magnfier in rasterscan mode
        navModesImHiddenIn[_defines2.default.eNavModes.nmAutoPan] = true; // hide magnfier in when auto panning
        _defines2.default.setAnnotNavModes(navModesImHiddenIn); // hide magnfier when drawing any annotation

        load_(); // load the magnfier

        // allow the magnifier updates but don't refresh on self call
        self.resume();
    };

    self.updateVisibility = function () {
        var isVisible = uScope.prefGet(_defines2.default.clsDIVMAG) && viewport.getImageIdx() === uScope.getSelImageIdx() && !navModesImHiddenIn[viewport.navModeGet()];
        show(isVisible);
    };

    var show = function show(_show) {
        if (!isLoaded) {
            return;
        }

        if (_show) {
            jMagCtlDiv.show();
            self.refresh();
        } else {
            jMagCtlDiv.hide();
        }

        reLayout(layout.precinct); // layout just this overlay's precinct
    };

    //............................................ refresh() public
    //    This function updates the magnifier's view if it is visible.
    //    Notes:
    //        Unlike the viewport, the magnifier is not concerned about requesting tiles, it requests the region of interest.
    //        If the view is at 20x and the magFactor is 2 then the magnifier displays a 40x image
    //        Note that ImageServer's GETImage likes zoom : 0.5 = 200%, 1 = 100%, 2 = 50%, 4 = 25% (counter intuitive)
    this.refresh = function () {
        if (jMagCtlDiv == undefined) return;
        if (jMagCtlDiv.is(':visible') == false) return; // if the magnifier is not visible, return

        // in modes like autopanning, the magnifier update gets in the way
        // so these modes suspend the magnifier. If it is suspended, return now.
        if (magSuspended) return;

        var magZoom = Number((viewport.getViewZoom() / magSpecs.magFactor).toFixed(2)); // magnifier zoom
        var csMag = new _objects.Size(jMagCtlDiv.width(), jMagCtlDiv.height()); // dimensions of the magnifier in pixels

        var e = jQuery.Event('', { // create an event at center  of the mag
            pageX: parseInt(jMagCtlDiv.offset().left + csMag.w / 2),
            pageY: parseInt(jMagCtlDiv.offset().top + csMag.h / 2)
        });

        var cpMagCenter = _defines2.default.coordBaseImage(e, viewport); // compute the position of the mag center in base image coords
        var cpMagLT = new _objects.Point(cpMagCenter.x - csMag.w / 2 * magZoom, // then back up to the mag left-top corner
        cpMagCenter.y - csMag.h / 2 * magZoom);
        cpMagLT.toInt();

        cpMagLT.x = '0' + cpMagLT.x; // append a leading 0 to the requested coordinates
        cpMagLT.y = '0' + cpMagLT.y; // so they are interpreted by ImageServer as relative to the image base coords
        // build the url
        var sMagImgSrc = viewport.urlBuilder.region(cpMagLT.x, cpMagLT.y, csMag.w, csMag.h, magZoom);

        var jRegion = regionBuildDiv(sMagImgSrc, viewport);
        jRegion.attr('class', _defines2.default.clsIMGMAG); // change the class name from us.clsIMGREGION to us.clsIMGMAG

        var jMagWrapDiv = jMagCtlDiv.find('.' + _defines2.default.clsDIVIMGWRAP); // display the magnified region
        var jMatches = jMagWrapDiv.find('.' + _defines2.default.clsIMGMAG);
        if (jMatches.length) // if the mag currently has an image
            jMatches.replaceWith(jRegion); // replace it
        else // otherwise
            jMagWrapDiv.append(jRegion); // add the new region to the magnifier

        var angleRad = viewport.getViewAngle();
        if (angleRad != 0.0) (0, _helpers.divRotate)(jRegion[0], 0, 0, jRegion.width(), jRegion.height(), angleRad);
    };

    //............................................ suspend() public
    //    This function disables magnifier image updates.
    this.suspend = function () {
        magSuspended = true;
    };
    //............................................ resume() public
    //    This function enables magnifier image updates
    //    and refreshes the magnifier if the passed parm 'doRefresh' is true.
    this.resume = function (doRefresh) {
        magSuspended = false;
        if (doRefresh) self.refresh();
    };
    //............................................ center() public
    //    This function centers the magnifier in the views.
    this.center = function (bDoRefresh) {
        if (jMagCtlDiv == undefined) return;

        var vpDivDims = viewport.vpDivDimsGet();
        var left = Math.round((vpDivDims.w - jMagCtlDiv.width()) / 2);
        var top = Math.round((vpDivDims.h - jMagCtlDiv.height()) / 2);
        jMagCtlDiv.css({ 'left': left + 'px', 'top': top + 'px' });

        if (_.isUndefined(bDoRefresh) || bDoRefresh) self.refresh();
    };

    //............................................ load_() local
    //    This function builds the magnfier control and calls into the layout manager
    //        to position it according to its layout settings.
    var load_ = function load_() {
        if (jMagCtlDiv) return; // if this viewport already has a magnifier, return

        var sDiam = magSpecs.initialDiameter + 'px';
        jMagCtlDiv = $('<div/>', { // build the div tag that contains the magnified images
            'class': _defines2.default.clsDIVMAG + ' ' + _defines2.default.clsSUPEROVERLAY,
            css: {
                'width': sDiam,
                'height': sDiam,

                '-moz-border-radius': sDiam,
                '-webkit-border-radius': sDiam,
                'border-radius': sDiam,
                '-khtml-border-radius': sDiam
            }
        });
        // add an inner div before the magnified image
        var jMagWrapDiv = $('<div/>', { 'class': _defines2.default.clsDIVIMGWRAP }); // necessary for webkit browsers for round mag and the resizer knob
        jMagCtlDiv.append(jMagWrapDiv);

        jVpDiv.append(jMagCtlDiv); // place the magnifier div in the viewport
        jMagCtlDiv = jVpDiv.find('.' + _defines2.default.clsDIVMAG); // save a quick access reference to the magnifier div

        viewport.overLayout.add(layout); // and call into layout with parms to place the div

        isLoaded = true;
        self.updateVisibility(); // show/hide according to user preferences
        bindEvents_(); // add event handlers
        jMagCtlDiv.click(); // add resize handles now
        return;

        //..................................................
        // closure functions
        //............................................ bindEvents_()
        // bindEvents_ - This function adds the magnifier event handlers.
        //
        //    Note that by using the same namespace as the viewport when the
        //    viewport removes its events by namespace, these are also removed.

        function bindEvents_() {
            uScope.events.on('uscope:viewport:selected', self.updateVisibility);
            uScope.userPrefs.events.on('load', self.updateVisibility);
            uScope.userPrefs.events.on('change:' + _defines2.default.clsDIVMAG, self.updateVisibility);

            // TODO: Think about how magnifier might leverage new renderer
            viewport.renderer.addLayer({
                paint: debounce(self.refresh.bind(self))
            });
            viewport.events.on('viewport:resize', self.refresh);

            $(_defines2.default.idHashROOT).on(_defines2.default.evMODECHANGE + namespace, self.updateVisibility);

            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTVISIBLE + namespace, function saveSettings(e, parms) {
                uScope.prefSet(_defines2.default.clsDIVMAG, prefVisibleDef);
            });

            jMagCtlDiv.resizable({
                cursor: 'auto',
                handles: 'se',
                containment: 'parent',
                aspectRatio: 1,
                distance: 3,
                minWidth: magSpecs.minDiameter,
                minHeight: magSpecs.minDiameter,
                maxWidth: magSpecs.maxDiameter,
                maxHeight: magSpecs.maxDiameter,
                resize: function resize(e) {
                    clear_();
                    resize_(true);
                    e.preventDefault();
                    return false;
                },
                stop: function stop(e, ui) {
                    self.refresh();
                    return false;
                }
            });

            jMagCtlDiv.draggable({
                cursor: 'move',
                containment: 'parent',
                opacity: 0.0,
                start: function start(e, ui) {
                    clear_();
                    showCrosshairs_(true, false); // show mag crosshairs without resizing
                    return true; // important NOT to stop propagation here
                },
                drag: function drag(e, ui) {
                    return true; // important NOT to stop propagation here
                },
                stop: function stop(e, ui) {
                    layout.canBePlaced = false; // reposition only when magnifier is not fully within view
                    showCrosshairs_(false);
                    self.refresh();
                    return true; // important NOT to stop propagation here
                }
            });

            // click event adds the magnifier's resize handles once
            jMagCtlDiv.on('click' + namespace, function (e) {
                if ($(this).attr('hasHandles') == undefined) {
                    $(this).attr('hasHandles', true);

                    $(this).resizable({ handles: 'se' });
                    var jResizer = jVpDiv.find('.' + _defines2.default.clsDIVMAG + ' .ui-resizable-se');
                    jResizer.css({ 'left': '84%', 'top': '84%' });
                }
            });

            jMagCtlDiv.on('mousedown' + namespace, function (e) {
                clear_();
                showCrosshairs_(true, false); // show mag crosshairs without resizing
                return false; // prevent propigation to VP
            });

            jMagCtlDiv.on('mousemove' + namespace, function (e) {
                return true; // propigate necessary or scalebar resize does not reduce in size
            });

            jMagCtlDiv.on('mouseup' + namespace, function (e) {
                showCrosshairs_(false);
                self.refresh();
                return true; // propigate necessary or scalebar resize does not release
            });
        }
    };

    //............................................ resize_() local
    //    This function resizes the magnifier, sets its shape and its crosshairs.
    //    Optionally and by default, it refreshes its magnified image.
    var resize_ = function resize_(bDoRefresh) {
        if (jMagCtlDiv == undefined) return;

        var width = jMagCtlDiv.width();
        width = Math.max(magSpecs.minDiameter, width);
        var str = width + 'px';
        jMagCtlDiv.css({
            'width': str,
            'height': str,
            '-moz-border-radius': str,
            '-webkit-border-radius': str,
            'border-radius': str,
            '-khtml-border-radius': str
        });

        showCrosshairs_(true, true); // resize and show the crosshairs inside the magnifier
        if (_.isUndefined(bDoRefresh) || bDoRefresh) // if instructed, refresh the magnifier image
            self.refresh();
    };
    //............................................ clear_() local
    //    This function removes the content from the magnifier.  It is used to show the
    //    underlying image when the magnifier is resizing or dragging.
    var clear_ = function clear_() {
        if (jMagCtlDiv == undefined) return;

        // if there is a region from a previous position in the mag, hide it
        var jMatches = jMagCtlDiv.find('.' + _defines2.default.clsIMGMAG);
        if (jMatches.length) jMatches.hide();
    };
    //............................................ showCrosshairs_() local
    //    This function draws and shows/hides the crosshairs in the magnifier.
    var showCrosshairs_ = function showCrosshairs_(show, resizeX) {
        if (jMagCtlDiv == undefined) return;
        if (xHairAlwaysShow_ == true) show = xHairAlwaysShow_; // override show if always show is enabled

        var jMagXHairs = jMagCtlDiv.find('.' + _defines2.default.clsMAGXHAIR); // find the cross hairs

        if (show && (resizeX || jMagXHairs.length == 0)) {
            // if showing and (instructed to resize or the xhairs don't yet exist)
            if (jMagXHairs.length > 0) // if they exist, remove them
                jMagXHairs.remove();

            var width = jMagCtlDiv.width(); // and rebuild them
            var classes = _defines2.default.clsMAGXHAIR + ' ' + _defines2.default.clsSUPEROVERLAY;

            if (xHairFullDiam_ == false) {
                var length = Math.floor(width / 2 - width / 8) + 'px';
                var offsetLT = Math.floor(width / 2 + width / 8) + 'px';
                var radius = Math.floor(width / 2) + 'px';
            } else {
                var length = Math.floor(width / 2) + 'px';
                var offsetLT = Math.floor(width / 2) + 'px';
                var radius = Math.floor(width / 2) + 'px';
            }

            var jXHair = $('<div/>', {
                'class': classes,
                css: { 'left': '0px', 'top': radius, 'width': length, 'height': '2px' }
            });
            jMagCtlDiv.append(jXHair); // place the horiz left crosshairs in the magnifier
            var jXHair = $('<div/>', {
                'class': classes,
                css: { 'left': offsetLT, 'top': radius, 'width': length, 'height': '2px' }
            });
            jMagCtlDiv.append(jXHair); // place the horiz right crosshairs in the magnifier
            jXHair = $('<div/>', {
                'class': classes,
                css: { 'left': radius, 'top': '0px', 'width': '2px', 'height': length }
            });
            jMagCtlDiv.append(jXHair); // place the vert top crosshairs in the magnifier
            jXHair = $('<div/>', {
                'class': classes,
                css: { 'left': radius, 'top': offsetLT, 'width': '2px', 'height': length }
            });
            jMagCtlDiv.append(jXHair); // place the vert bottom crosshairs in the magnifier
        }

        if (show) jMagXHairs.show();else jMagXHairs.hide();
    };

    //............................................ construction
    construct_();
}

function regionBuildDiv(sRegImgSrc, thisImg, opt_cbOnRegionLoad) {
    return $('<img/>', {
        load: function load(e) {
            if (opt_cbOnRegionLoad) opt_cbOnRegionLoad(self);
        },
        error: function error(e) {
            // ('..regionBuildDiv: load error', e); // eslint-disable-line no-undef
        },

        class: _defines2.default.clsIMGREGION,
        src: sRegImgSrc,
        alt: ''
    });
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var timeout = void 0;
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var context = this;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
module.exports = exports['default'];

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _magnifierControl = __webpack_require__(422);

var _magnifierControl2 = _interopRequireDefault(_magnifierControl);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

var _browserCompatibility = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loader = {
    name: 'us:magnifier',

    extends: 'viewport',

    canStart: function canStart() {
        if (_browserCompatibility.env.isIOS || _browserCompatibility.env.isIEBelow9) {
            // The IE check should not be here. TODO: IE8 and below are no longer supported.
            _defines2.default.ENABLEMAG = false;
            return false;
        }
        return true;
    },


    constructor: _magnifierControl2.default
};

_publicApi2.default.plugins.register(loader);

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(337);


/***/ })

},[623]);